import moment from 'moment';

export const formatNumber = (value) => (Number.isFinite(value) ? value.toLocaleString('en-GB') : '-');

export const formatPct = (value) => {
    if (!Number.isFinite(value)) return '-';
    return `${value > 0 ? '+' : ''}${value.toFixed(1)}%`;
};

export const pctColor = (value) => {
    if (!Number.isFinite(value) || value === 0) return 'text.secondary';
    return value > 0 ? 'success.main' : 'error.main';
};

export const formatDay = (dayKey) => (dayKey ? moment(dayKey, 'YYYY-MM-DD').format('D MMM') : '-');
